angular
	.module('empower.modules')
	.constant('jurisdictionEnum', {
		ALL: null,
		NSW: 0,
		NSI: 1,
		VIC: 2,
		ACT: 3
	});